// extracted by mini-css-extract-plugin
export var optionGrid = "_6v-7";
export var optionList = "_6v-6";
export var questionsBlock = "_6v-9";
export var spacer = "_6v-5";
export var stepCenteredContent = "_6v-3";
export var stepInner = "_6v-0";
export var stepInnerFullWidth = "_6v-1";
export var stepInnerLockScroll = "_6v-2";
export var stepTransitionFrame = "_6v-4";
export var welcomeBlock = "_6v-8";